import { useState } from 'react';
import { IonGrid, IonRow, IonCol, IonInput, IonTextarea, IonButton, IonLabel, IonItem, IonSelect, IonSelectOption, useIonToast } from '@ionic/react';
import { Constants } from '../../defines/Constants';
import { ValidateIranMobile, ValidateEmail } from '../../defines/Functions';
import axios from 'axios';
import Loading from '../Loading';
import './Form.css';

const Form = () => {
    const contactApi = Constants.api.contact;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        })
    };
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        text: ''
    });
    const [required, setRequired] = useState({
        name: { value: false, message: '' },
        email: { value: false, message: '' },
        phone: { value: false, message: '' },
        subject: { value: false, message: '' },
        text: { value: false, message: '' }
    });
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setFormData(values => ({ ...values, [name]: value }));
    }
    const handleBlur = () => {
        if (formData.name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, name: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, name: { value: false, message: '' } } });
        }
        if (formData.email.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'الزامی' } } });
        } else {
            if (!ValidateEmail(formData.email)) {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'آدرس ایمیل معتبر نیست' } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: false, message: '' } } });
            }
        }
        if (formData.phone.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, phone: { value: true, message: 'الزامی' } } });
        } else {
            if (!ValidateIranMobile(formData.phone)) {
                setRequired(prevRequired => { return { ...prevRequired, phone: { value: true, message: 'شماره موبایل معتبر نیست' } } });
            } else {
                setRequired(prevRequired => { return { ...prevRequired, phone: { value: false, message: '' } } });
            }
        }
        if (formData.subject.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, subject: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, subject: { value: false, message: '' } } });
        }
        if (formData.text.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: true, message: 'الزامی' } } });
        } else {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: false, message: '' } } });
        }
    }
    const handleSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        if (formData.name.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, name: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, name: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.email.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            if (!ValidateEmail(formData.email)) {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'آدرس ایمیل معتبر نیست' } } });
                isRequired = true;
            } else {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: false, message: '' } } });
                isRequired = false;
            }
        }
        if (formData.phone.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, phone: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            if (!ValidateIranMobile(formData.phone)) {
                setRequired(prevRequired => { return { ...prevRequired, phone: { value: true, message: 'شماره موبایل معتبر نیست' } } });
                isRequired = true;
            } else {
                setRequired(prevRequired => { return { ...prevRequired, phone: { value: false, message: '' } } });
                isRequired = false;
            }
        }
        if (formData.subject.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, subject: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, subject: { value: false, message: '' } } });
            isRequired = false;
        }
        if (formData.text.toString().trim().length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: true, message: 'الزامی' } } });
            isRequired = true;
        } else {
            setRequired(prevRequired => { return { ...prevRequired, text: { value: false, message: '' } } });
            isRequired = false;
        }
        if (!isRequired) {
            submitForm();
        }
    }
    const submitForm = async () => {
        setLoading(true);
        const submitData = {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            subject: formData.subject,
            text: formData.text
        };
        try {
            const formResults = await axios.post(contactApi, JSON.stringify(submitData), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (formResults.data.status === 'error') {
                showToast({ message: formResults.data.message, color: 'danger' });
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    text: ''
                });
                setLoading(false);
            } else {
                showToast({ message: formResults.data.message, color: 'success' });
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    text: ''
                });
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    return (
        <div className="form-contact-container">
            <form onSubmit={handleSubmit}>
                <IonGrid>
                    <IonRow>
                        {!loading ?
                            <IonCol size="12">
                                <h3 className="form-contact-title">فرم ارتباط با ما</h3>
                                <div className="form-contact-input-container">
                                    <IonRow>
                                        <IonCol size="12">
                                            <IonLabel>
                                                نام و نام خانوادگی
                                                {required.name.value ? <span className="required">{required.name.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="text" name="name" value={formData.name || ''} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>
                                                آدرس ایمیل
                                                {required.email.value ? <span className="required">{required.email.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="email" name="email" value={formData.email || ''} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>
                                                شماره موبایل
                                                {required.phone.value ? <span className="required">{required.phone.message}</span> : null}
                                            </IonLabel>
                                            <IonInput type="tel" name="phone" value={formData.phone || ''} onIonChange={handleChange} onIonBlur={handleBlur} />
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>
                                                موضوع پیام یا درخواست
                                                {required.subject.value ? <span className="required">{required.subject.message}</span> : null}
                                            </IonLabel>
                                            <IonItem lines="none">
                                                <IonLabel>موضوع پیام یا درخواست</IonLabel>
                                                <IonSelect
                                                    value={formData.subject}
                                                    onIonChange={e => setFormData({ ...formData, subject: e.detail.value })}
                                                    mode="md"
                                                    okText="تایید"
                                                    cancelText="لغو"
                                                >
                                                    <IonSelectOption value="انتقادات / پیشنهادات">
                                                        انتقادات / پیشنهادات
                                                    </IonSelectOption>
                                                    <IonSelectOption value="پیگیری خرید">
                                                        پیگیری خرید
                                                    </IonSelectOption>
                                                    <IonSelectOption value="مالی و حسابداری">
                                                        مالی و حسابداری
                                                    </IonSelectOption>
                                                    <IonSelectOption value="بخش فروش">
                                                        بخش فروش
                                                    </IonSelectOption>
                                                    <IonSelectOption value="پشتیبانی">
                                                        پشتیبانی
                                                    </IonSelectOption>
                                                    <IonSelectOption value="سوالات عمومی">
                                                        سوالات عمومی
                                                    </IonSelectOption>
                                                </IonSelect>
                                            </IonItem>
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonLabel>
                                                متن پیام
                                                {required.text.value ? <span className="required">{required.text.message}</span> : null}
                                            </IonLabel>
                                            <IonTextarea rows={5} name="text" value={formData.text || ''} onIonChange={handleChange} onIonBlur={handleBlur}></IonTextarea>
                                        </IonCol>
                                        <IonCol size="12">
                                            <IonButton type="submit" color="warning" expand="block" className="form-contact-submit-button">
                                                ارسال
                                            </IonButton>
                                        </IonCol>
                                    </IonRow>
                                </div>
                            </IonCol>
                            :
                            <Loading />
                        }
                    </IonRow>
                </IonGrid>
            </form >
        </div>
    );
};
export default Form;